module.exports = __webpack_public_path__ + "img/c7ebf6134dd64784a359ab7e2e70875c.6b9044a3.jpg";